import { render, staticRenderFns } from "./ApplyPass.vue?vue&type=template&id=201452b4&scoped=true&"
import script from "./ApplyPass.vue?vue&type=script&lang=js&"
export * from "./ApplyPass.vue?vue&type=script&lang=js&"
import style0 from "./ApplyPass.vue?vue&type=style&index=0&id=201452b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201452b4",
  null
  
)

export default component.exports